import { JobsView } from "../ws7/jobs/JobsView";
import "../ws7/ws7.css";

/** /jobs: pools, job list + detail with log tail, cancel/retry, source health with kill switches (WS7). */
export function JobsPage() {
  return <JobsView />;
}
